var _defs, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlugins({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 145.5,
    height: 145.5,
    viewBox: "0 0 145.5 145.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 21.35,
    y1: 124.15,
    x2: 124.15,
    y2: 21.35,
    gradientTransform: "translate(72.75 -30.13) rotate(45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9748a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d163ab"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 39.42,
    y1: 106.86,
    x2: 105.79,
    y2: 40.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#edbede"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 72.75,
    cy: 72.75,
    r: 72.75,
    transform: "translate(-30.13 72.75) rotate(-45)",
    fill: "url(#a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.28,38.7H45.51a8.66,8.66,0,0,0-8.65,8.65V64.12a8.66,8.66,0,0,0,8.65,8.65H62.28a8.66,8.66,0,0,0,8.64-8.65V47.35A8.66,8.66,0,0,0,62.28,38.7Zm3.64,25.42a3.65,3.65,0,0,1-3.64,3.65H45.51a3.65,3.65,0,0,1-3.65-3.65V47.35a3.65,3.65,0,0,1,3.65-3.65H62.28a3.65,3.65,0,0,1,3.64,3.65ZM62.28,75.3H45.51a8.66,8.66,0,0,0-8.65,8.64v16.77a8.66,8.66,0,0,0,8.65,8.65H62.28a8.66,8.66,0,0,0,8.64-8.65V83.94A8.66,8.66,0,0,0,62.28,75.3Zm3.64,25.41a3.64,3.64,0,0,1-3.64,3.65H45.51a3.64,3.64,0,0,1-3.65-3.65V83.94a3.64,3.64,0,0,1,3.65-3.64H62.28a3.64,3.64,0,0,1,3.64,3.64ZM99,75.3H82.22a8.66,8.66,0,0,0-8.65,8.64v16.77a8.66,8.66,0,0,0,8.65,8.65H99a8.66,8.66,0,0,0,8.64-8.65V83.94A8.66,8.66,0,0,0,99,75.3Zm3.64,25.41A3.64,3.64,0,0,1,99,104.36H82.22a3.65,3.65,0,0,1-3.65-3.65V83.94a3.65,3.65,0,0,1,3.65-3.64H99a3.64,3.64,0,0,1,3.64,3.64Zm9.12-54.26L99.89,34.59a8.66,8.66,0,0,0-12.23,0L75.81,46.45a8.64,8.64,0,0,0,0,12.23L87.66,70.53a8.65,8.65,0,0,0,12.23,0l11.86-11.85A8.66,8.66,0,0,0,111.75,46.45Zm-3.53,8.69L96.36,67a3.66,3.66,0,0,1-5.16,0L79.34,55.14a3.66,3.66,0,0,1,0-5.16L91.2,38.12a3.67,3.67,0,0,1,5.16,0L108.22,50A3.66,3.66,0,0,1,108.22,55.14Z",
    fill: "url(#b)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlugins);
export default __webpack_public_path__ + "static/media/plugins.8f436dc73e4f7f3f791bd983b4626013.svg";
export { ForwardRef as ReactComponent };